import * as yup from "yup";
import { SelectOptions } from "hooks";

export const emailTypes: SelectOptions[] = [
    { name: "PROOF", value: "PROOF" },
    { name: "MATERIAL", value: "MATERIAL" },
    { name: "TEARSHEET", value: "TEARSHEET" },
    { name: "ASSET", value: "ASSET" },
];

export const proofTypes: SelectOptions[] = [
    { name: "EMAIL", value: "EMAIL" },
    { name: "PDF", value: "PDF" },
];

export interface TemplateEditorFormSchema {
    name: string;
    userGroups?: SelectOptions[];
    materialSpec?: SelectOptions;
    emailType: string;
    proofType: string;
    language: string;
    cc: string;
    bcc: string;
    to: string;
    replyTo: string;
    from: string;
    subject: string;
    smsText: string;
    cellPhone: string;
    status: string;
}

export const templateEditorDefaultValues: TemplateEditorFormSchema = {
    name: "",
    emailType: "",
    proofType: "",
    language: "",
    cc: "",
    bcc: "",
    to: "",
    replyTo: "",
    from: "",
    subject: "",
    cellPhone: "",
    smsText: "",
    status: "",
};

export const templateEditorSchema = yup.object().shape({
    name: yup
        .string()
        .required("File name is required")
        .matches(/^.*\.(xml|vm|ftl)$/, "File name has incorrect extension. Allowed extension are: .xml, .vm, .ftl"),
    materialSpec: yup.object().nullable().default({}).shape({
        name: yup.string(),
        value: yup.string(),
    }),
    userGroups: yup.array().of(
        yup.object().nullable().shape({
            name: yup.string(),
            value: yup.string(),
        })
    ),
    language: yup.string(),
    cc: yup.string(),
    bcc: yup.string(),
    variables: yup.string(),
    emailType: yup.string(),
    proofType: yup.string(),
    to: yup.string().required("Recipient must be defined"),
    replyTo: yup.string(),
    from: yup.string().required("Sender must be defined"),
    subject: yup.string().required("Subject must be defined"),
    status: yup.string(),
    cellPhone: yup.string(),
    smsText: yup.string(),
});
